import { render, staticRenderFns } from "./EnvironmentBanner.vue?vue&type=template&id=b317fcd0&scoped=true&"
import script from "./EnvironmentBanner.vue?vue&type=script&lang=ts&"
export * from "./EnvironmentBanner.vue?vue&type=script&lang=ts&"
import style0 from "./EnvironmentBanner.vue?vue&type=style&index=0&id=b317fcd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b317fcd0",
  null
  
)

export default component.exports